var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIcCalendarMinus({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.09257 1.66797C6.55281 1.66797 6.92591 2.04106 6.92591 2.5013V2.95368H13.7513V2.5013C13.7513 2.04106 14.1244 1.66797 14.5846 1.66797C15.0449 1.66797 15.418 2.04106 15.418 2.5013V3.06039C16.8678 3.44023 17.918 4.7881 17.918 6.35842L17.918 14.9299C17.918 16.788 16.4476 18.3346 14.5846 18.3346H6.2513C4.38838 18.3346 2.91797 16.788 2.91797 14.9299V6.35842C2.91797 4.84601 3.89215 3.53995 5.25924 3.10632V2.5013C5.25924 2.04106 5.63233 1.66797 6.09257 1.66797ZM6.2513 4.62034C5.3528 4.62034 4.58464 5.37623 4.58464 6.35842V6.59651H16.2513V6.35842C16.2513 5.37623 15.4831 4.62034 14.5846 4.62034H6.2513ZM16.2513 8.26318H4.58464V14.9299C4.58464 15.9121 5.3528 16.668 6.2513 16.668H14.5846C15.4831 16.668 16.2513 15.9121 16.2513 14.9299L16.2513 8.26318ZM7.5013 12.1441C7.5013 11.6839 7.8744 11.3108 8.33464 11.3108H12.5013C12.9615 11.3108 13.3346 11.6839 13.3346 12.1441C13.3346 12.6044 12.9615 12.9775 12.5013 12.9775H8.33464C7.8744 12.9775 7.5013 12.6044 7.5013 12.1441Z",
    fill: "#116584"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcCalendarMinus);
export default __webpack_public_path__ + "static/media/ic-calendar-minus.4acd26682c36dad159b644058d70c88e.svg";
export { ForwardRef as ReactComponent };